import { Image } from 'expo-image'
import { type PropsWithChildren } from 'react'
import { Platform, View } from 'react-native'
import Animated, { FadeIn } from 'react-native-reanimated'
import { type BackgroundTheme, useAppView } from '~/components/layout/AppViewContext'
import { backgrounds } from '~/lib/themeImages.tsx'
import { cn } from '~/lib/utils.ts'

const isSafariApp =
  Platform.OS === 'web' &&
  /iPad|iPhone/.test(navigator.userAgent) &&
  !navigator.userAgent.includes('CriOS') &&
  !navigator.userAgent.includes('FxiOS')

export type AppViewProps = PropsWithChildren<{
  backgroundTheme?: BackgroundTheme
  className?: string
}>

export function AppView({
  children,
  backgroundTheme: defaultBackgroundTheme,
  className,
}: AppViewProps) {
  const { backgroundTheme } = useAppView()

  const currentBackgroundTheme = backgroundTheme ?? defaultBackgroundTheme

  return (
    <Animated.View
      className={cn('h-full max-h-screen flex-1', className)}
      entering={FadeIn.duration(150)}>
      {currentBackgroundTheme !== 'primary' && backgrounds[currentBackgroundTheme ?? 0] && (
        <View
          key={currentBackgroundTheme}
          style={{
            position: Platform.select({
              native: 'absolute' as const,
              default: 'fixed' as const,
            }),
            inset: 0,
            height: '100%',
            width: '100%',
            backgroundColor: 'transparent',
          }}>
          <Image
            key={`${currentBackgroundTheme}image`}
            source={backgrounds[currentBackgroundTheme as number]}
            style={{
              height: '100%',
              width: '100%',
              borderRadius: isSafariApp ? 41 : 0,
            }}
            contentFit="cover"
          />
        </View>
      )}
      {children}
    </Animated.View>
  )
}
